import { render } from "./Nav_fitbar.vue?vue&type=template&id=6a0416df"
import script from "./Nav_fitbar.vue?vue&type=script&lang=js"
export * from "./Nav_fitbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__